import React from 'react';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { Button } from 'wbm-inputs';

type ConfigPropsType = {
    usePunchout: Boolean,
    enableSinglePageCheckout: Boolean,
}

type CheckoutProps = {
    configProps: ConfigPropsType,
    hasItemAgreements: Boolean,
    checkoutAppUri: string,
    isLoggedIn: Boolean,
    loginUrl: string,
    ecomBaseUrl: string
    shoppingCartUrl: string
}

export const Checkout = ({ ...props }: CheckoutProps) => {

    const getCheckoutUrl = () => {
        let checkoutUrl = '';
        if (props.hasItemAgreements) {
            checkoutUrl = props.shoppingCartUrl;
          } else {
            if (
              props.configProps.usePunchout
            ) {
                checkoutUrl = `${props.ecomBaseUrl}Punchout.aspx`;
            } else if (
              props.checkoutAppUri &&
              props.configProps.enableSinglePageCheckout           
            ) {
                checkoutUrl = props.checkoutAppUri;
            } else {
                checkoutUrl = `${props.ecomBaseUrl}ShippingAddress.aspx`;
            }
          }
        return checkoutUrl;
    }

    return (
        <a href={getCheckoutUrl()}>
            <Button className="btn btn-primary">{props.hasItemAgreements ? 'CONTINUE TO CART' : 'CHECKOUT'}</Button>
        </a>
    );
}
